import { Table } from 'antd'

import { BitazzaText } from '../../../../components'
import { getColor } from '../../../../util/getColor'
import { Badges } from '../Badges'
import Styles from './UserRank.module.scss'
import { formatNumber } from '../../../../util/formatNumber'
import { useMediaQuery } from 'react-responsive'

interface Props {
    rank?: number | string
    score: string
    name?: string
    tier: string
    selectedRankTab: string
}

export const UserRank: React.FC<Props> = ({
    rank,
    score,
    name,
    tier,
    selectedRankTab,
}) => {
    const isDesktop = useMediaQuery({ minWidth: 768 })
    const columns = [
        {
            dataIndex: 'rank',
            key: 'rank',
            width: isDesktop ? '6.2%' : '13%',
            render(text: string) {
                return (
                    <BitazzaText
                        content={text}
                        color="#fff"
                        format={isDesktop ? 't24' : 't14'}
                        bold={isDesktop}
                        noWrap
                    />
                )
            },
        },
        {
            dataIndex: 'name',
            key: 'name',
            width: '48%',
            render(text: string, record: any) {
                return (
                    <div className={Styles.containerSecondTable}>
                        <div className={Styles.tableName}>
                            <Badges type={record.type} userRank />
                            <BitazzaText
                                content={`@${text}`}
                                color="#fff"
                                format={isDesktop ? 't24' : 't14'}
                                bold={isDesktop}
                                noWrap
                            />
                        </div>
                    </div>
                )
            },
        },
        {
            dataIndex: 'pnl',
            key: 'pnl',

            render(text: number) {
                return (
                    <div className={Styles.pnlWrapper}>
                        <BitazzaText
                            content={`${formatNumber(
                                +text,
                                false,
                                true,
                                true,
                                false
                            )}%`}
                            color={getColor(+text, true)}
                            format={isDesktop ? 't24' : 't14'}
                            bold={isDesktop}
                            strong
                            noWrap
                        />
                    </div>
                )
            },
        },
    ]

    const data = [
        {
            key: rank,
            rank: rank,
            name: name,
            pnl: score || 0,
            type: tier,
        },
    ]

    return (
        <div
            className={
                selectedRankTab === 'top100'
                    ? Styles.container
                    : Styles.containerMyRanking
            }
        >
            <div className={Styles.tableUser}>
                <Table
                    showHeader={false}
                    tableLayout="fixed"
                    className={Styles.table}
                    bordered={false}
                    rowClassName={Styles.rowUserRank}
                    dataSource={data}
                    columns={columns}
                    pagination={false}
                />
            </div>
        </div>
    )
}
